import { Box, Typography } from '@mui/material'
import { useContext } from 'react'

import { AppSettingsContext } from '../Contexts'
import WorldBasePage from './WorldBasePage'

const SplitPage: React.FC = () => {
  const { developerMode } = useContext(AppSettingsContext)

  if (developerMode === false) {
    return (
      <WorldBasePage>
        <Box alignItems="center" display="flex" flexGrow={1} justifyContent="center" width="100vw">
          <Typography variant="h4">Coming Soon</Typography>
        </Box>
      </WorldBasePage>
    )
  }

  return (
    <WorldBasePage>
      <Box alignItems="center" display="flex" flexGrow={1} justifyContent="center" width="100vw">
        <Typography variant="h4">Coming Soon</Typography>
      </Box>
    </WorldBasePage>
  )
}

export default SplitPage
